export const facilitiesDataActions = {
  populateFacilities: "POPULATE_FACILITIES"
};
